import Tourism from "./Tourism.jsx";
export default Tourism